import { Component, OnInit, HostListener, Input, ElementRef, EventEmitter, ViewChild, Output, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { NotificationsService } from 'src/app/services/notifications.service';
import { InstitutionService } from 'src/app/services/institution.service';
import { ProjectService } from 'src/app/services/project.service';
import { EventService } from 'src/app/services/event.service';
import { JobService } from 'src/app/services/job.service';

@Component({
  selector: 'oc-nav-profile',
  templateUrl: './nav-profile.component.html',
  styleUrls: ['./nav-profile.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class NavProfileComponent implements OnInit, OnDestroy {
  @ViewChild('profileNavEl', { static: false }) profileNavEl: ElementRef;
  @ViewChild('notificationsNavEl', { static: false }) notificationsNavEl: ElementRef;
  subscriptions: Subscription = new Subscription();
  @Input() location = 'left';
  @Input() userNotifications;
  @Input() user;
  @Input() mobile = false;
  @Output() menuEmit: EventEmitter<any> = new EventEmitter();
  unreadNotifications = false;
  // user;
  profileNav = {
    toggled: false,
    listItems: [
      { routerLink: 'm/add-institution', label: 'Add Institution' },
      { routerLink: 'm/add-project', label: 'Add Project' },
      { routerLink: 'm/add-event', label: 'Add Event' },
      { routerLink: 'm/add-job', label: 'Add Job' },
      { routerLink: 'settings', label: 'Settings' },
      { routerLink: 'notifications', label: 'Notifications' },
    ],
  };
  notificationsNav = {
    toggled: false,
  };
  innerWidth;
  userLists = {
    institutions: [],
    projects: [],
    events: [],
    jobs: [],
  };

  constructor(
    private userService: UserService,
    private notificationsService: NotificationsService,
    private _eref: ElementRef,
    private institutionService: InstitutionService,
    private projectService: ProjectService,
    private eventService: EventService,
    private jobService: JobService
  ) {}

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.mobile = this.innerWidth < 992 ? true : false;
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.user = u;
          this.notificationsService.getUserNotifications(this.user.uid).subscribe((n) => {
            this.userNotifications = n;
            this.userNotifications.forEach((notif) => {
              notif['timeAgo'] = this.notificationsService.getHowLongAgo(notif.date.toDate());
              if (!notif.read) {
                this.unreadNotifications = true;
              }
            });
          });

          // Get user owned posts
          ['institution', 'project', 'event', 'job'].forEach((label) => {
            let listLabel = label.substring(0, 1).toUpperCase() + label.substring(1) + 's';
            let listId = label + 's';
            this[label + 'Service']['getCurrentUserOwned' + listLabel](this.user.uid).subscribe(
              (l) => {
                this.userLists[listId] = this.userLists[listId].concat(l);
              },
              (e) => console.error(e)
            );

            // Get posts user is participating in
            if (listId !== 'jobs') {
              this[label + 'Service']['getCurrentUser' + listLabel](this.user[listId]).subscribe((arr) => {
                if (arr.length) {
                  arr.forEach((i$) => {
                    i$.subscribe((i) => {
                      if (i && !this.userLists[listId].some((li) => i[0].id && i.id === i[0].id)) {
                        this.userLists[listId].push(i[0]);
                      }
                    });
                  });
                }
              });
            }
          });
        }
      })
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.mobile = this.innerWidth < 992 ? true : false;
  }

  toggleDropdown(obj) {
    obj.toggled = !obj.toggled;
  }
  toggleMobileMenu() {
    this.menuEmit.emit('click');
  }

  openAndMarkAsRead() {
    if (!this.notificationsNav.toggled) {
      this.notificationsNav.toggled = true;
      if (this.userNotifications) {
        this.userNotifications.forEach((n) => {
          if (!n.read) {
            n.read = true;
            this.notificationsService.updateNotification(n.id, { read: true });
          }
        });
        this.unreadNotifications = false;
      }
    } else {
      this.notificationsNav.toggled = false;
    }
    if (this.profileNav.toggled) {
      this.profileNav.toggled = false;
    }
  }

  logout() {
    this.userService.logout();
  }

  onClick(event) {
    // console.log(event.target);
    // const notification = event.target.classList.contains('dropdown-wrap') ?
    //   event.target.contains('notification-wrap') :
    //   event.target.closest('.dropdown-wrap').classList.contains('notification-wrap');
    if (this.notificationsNav.toggled) {
      if (!this.notificationsNavEl.nativeElement.contains(event.target)) {
        if (this.notificationsNav.toggled) this.notificationsNav.toggled = false;
      }
    } else {
      if (!this.profileNavEl.nativeElement.contains(event.target)) {
        if (this.profileNav.toggled) this.profileNav.toggled = false;
      }
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
